module.exports = __webpack_public_path__ + "images/line_lp/section1-left-image_a11b3e91907c199ccf90cc257f287367.png";